module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@3x-e2439d5cf748e4d85bc30932632a666e.webp";